export const TEXTS = {
    systemOffline: "SYSTEM OFFLINE",
    authRequired: "AUTHORIZATION REQUIRED",
    enterCode: "ENTER ACCESS CODE",
    accessDenied: "ACCESS DENIED",
    accessGranted: "ACCESS GRANTED",
    wakingGrid: "WAKING PRIMARY GRID",
    powerGridOnline: "POWER ROUTING ONLINE",
    lightingOnline: "HALL LIGHTING ONLINE",
    pressureOnline: "PRESSURE & MOTION ONLINE",
    heartLineOnline: "HEART CORE IGNITION",
    productionOnline: "LOVE LINE ONLINE",
    synchronized: "FACILITY HEARTBEAT SYNCHRONIZED",
    facilityOnline: "LOVE FACTORY ONLINE"
};
